import PagerConfig from "@/config/pager.js"
import Permit from '@/utils/permit.js'
// import Util from '@/utils'

export const table = {
  basic: {
    data() {
      return {
        records: [],
        loading: false,
        mergeCells: [],
      }
    },
    mounted() {
      this.loadData()
    },
    computed: {
      implicit() {
        return {};
      },
    },
    methods: {
      loadData() {
        this.loading = true
        let self = this
        this.dataProvider(self.combineParams()).then(function (result) {
          let data = result.data
          self.recordsDecorate(data.records)
          if (self.pager) {
            self.pager.total = data.total
            self.pager.productNoQty = data.productNoQty
            self.pager.qtyTotal = data.qtyTotal
            self.pager.moneyTotal = data.moneyTotal
            self.pager.customCount = data.customCount

          }
          self.loading = false
        })
      },
      recordsDecorate(records) {
        this.records = records;
      },
      combineParams() {
        let params = {}
        if (this.pager) {
          params.currentPage = this.pager.currentPage
          params.pageSize = this.pager.pageSize
        }
        if (this.actionSorter) {
          for (let key in this.actionSorter) {
            if (this.actionSorter[key]) {
              params[key] = this.actionSorter[key]
            }
          }
        }
        if (this.searchForm) {
          for (let key in this.searchForm) {
            if (this.searchForm[key]) {
              params[key] = this.searchForm[key]
            }
          }
        }
        if (this.filters) {
          for (let filter of JSON.parse(JSON.stringify(this.filters))) {
            for (let property in filter) {
              params[property] = filter[property]
            }
          }
        }
        if (this.implicit) {
          for (let key in this.implicit) {
            if (this.implicit[key]) {
              params[key] = this.implicit[key]
            }
          }
        }
        return params;
      },
      checkColumnMethod({ column }) {
        if (column.property == 'checkbox' || column.property == 'action') {
          return false
        }
        return true;
      },
      rowBgColor({ row, rowIndex }) {
        if (this.isNear(row)) {
          return 'near-bg'
        }
        if (this.isPass(row)) {
          return 'pass-bg'
        }
        return ''
      },
      isNear(record) {
        return false
      },
      isPass(record) {
        return false
      },
      mergeMethod({ rowIndex, columnIndex }) {
        const mergeCells = this.mergeCells
        for (let mIndex = 0; mIndex < mergeCells.length; mIndex++) {
          const { row, col, rowspan, colspan } = mergeCells[mIndex]
          if (row === rowIndex && col === columnIndex) {
            return { rowspan, colspan }
          }
          if (rowIndex >= row && rowIndex < row + rowspan && columnIndex >= col && columnIndex < col + colspan) {
            return { rowspan: 0, colspan: 0 }
          }
        }
        return { rowspan: 1, colspan: 1 }
      }
    }
  },
  pager: {
    data() {
      return {
        pagerConfig: PagerConfig.normal,
        pager: {
          currentPage: 1,
          pageSize: PagerConfig.normal.defaultPageSize,
          total: 0,
          productNoQty: 0,
          qtyTotal: 0,
          moneyTotal: 0,
          customCount: 0,
        },
      }
    },
    methods: {
      changePager(params) {
        this.pager.currentPage = params.currentPage
        this.pager.pageSize = params.pageSize
        this.loadData()
      },
    }
  },
  narrow: {
    data() {
      return {
        narrows: [],
        filters: [],
        initFilter: null,
      }
    },
    mounted() {
      this.initFilterCondition()
    },
    methods: {
      initFilterCondition() {
        if (this.initFilter) {
          outer:
          for (let row of this.narrows) {
            for (let filter of row) {
              for (let item of filter.items) {
                if (typeof this.initFilter == 'string' && item.key == this.initFilter) {
                  this.filters = [item.condition]
                  break outer
                }
                if (typeof this.initFilter == 'object' && this.initFilter.includes(item.key)) {
                  this.filters.push(item.condition)
                }
              }
            }
          }
        }
      },
      narrowSelect(filters) {
        this.pager.currentPage = 1
        this.pager.pageSize = PagerConfig.normal.defaultPageSize
        this.filters = filters
        this.loadData()
      },
    },
  },
  search: {
    data() {
      return {
        searchForm: {}
      }
    },
    methods: {
      search() {
        this.pager.currentPage = 1
        this.pager.pageSize = PagerConfig.normal.defaultPageSize
        this.loadData()
      }
    }
  },
  sorter: {
    data() {
      return {
        sorterMap: {},
        actionSorter: {
          sortBy: null,
          sortIndicator: null
        },
        sorter: {
          sortBy: null,
          sortIndicator: null
        },
      }
    },
    created() {
      this.actionSorter.sortBy = this.sorter.sortBy
      this.actionSorter.sortIndicator = this.sorter.sortIndicator
    },
    methods: {
      sortRecords({ column, property, order }) {
        if (!order) {
          this.actionSorter.sortBy = this.sorter.sortBy;
          this.actionSorter.sortIndicator = this.sorter.sortIndicator
        } else {
          this.actionSorter.sortBy = this.sorterMap[property];
          this.actionSorter.sortIndicator = order
        }
        this.loadData()
      },
    }
  },
  checker: {
    data() {
      return {
        selectRecordQty: 0,
        selectRecords: []
      }
    },
    methods: {
      setSelected() {
        this.setSelectedQty()
        this.selectRecords = this.$refs.recordsTable && this.$refs.recordsTable.getCheckboxRecords() || []
      },
      setSelectedQty() {
        this.selectRecordQty = this.$refs.recordsTable && this.$refs.recordsTable.getCheckboxRecords().length
      },
      clearSelected() {
        this.$refs.recordsTable.clearCheckboxRow()
        this.setSelectedQty()
        this.setSelected()
      },
    }
  },
}
export const page = {
  data() {
    return {
      Permit: Permit,
      // Util: Util,
      loading: true,
      loadingService: null
    }
  },
  methods: {
    loadingStart() {
      this.loading = true
      this.loadingService = this.$loading({ fullscreen: true, text: this.$t('text.doing') })
    },
    loadingEnd() {
      this.loading = false
      this.loadingService.close()

    },
    sysError() {
      console.log("======", this.$t('text.sysError'))
      // this.$message.error(this.$t('text.sysError'))
    },
    sysResults(data, successMseeage) {
      if (data.allQuantity == data.successQuantity) {
        if (successMseeage && successMseeage != null) {
          const text = "总 " + data.allQuantity + " 条,失败 " + data.failQuantity + " 条";
          this.$message({
            dangerouslyUseHTMLString: true,
            message: text + "<br/>" + successMseeage,
            type: "success",
          });
          return
        }
        this.$message({
          message: '操作成功',
          type: "success",
        });
      } else {
        const text = "总 " + data.allQuantity + " 条,失败 " + data.failQuantity + " 条，失败原因:<br/><br/>";
        let detail = "";
        for (const r of data.results) {
          if (r.type == 'success') {
            continue;
          }
          detail =
            detail +
            "<div style='margin-bottom: 2px'>" +
            r.message +
            "<div>";
        }
        this.$message({
          dangerouslyUseHTMLString: true,
          message: text + detail,
          type: "warning",
        });

      }
    },
    sysResult(data) {
      this.$message({
        message: data.message,
        type: data.type == 'success' ? "success" : "error",
      });
    },
    limitNumber() {
      return 60000
    },
    downloadChecked(datas) {
      if (datas.length == 0 || datas.length > this.limitNumber()) {
        this.$message({
          message: '勾选记录需大于0小于' + this.limitNumber(),
          type: "error",
        });
        return false
      }
      return true
    },
    downloadSearch(number) {
      if (number == 0 || number > this.limitNumber()) {
        this.$message({
          message: '搜索出来的记录需大于0小于' + this.limitNumber(),
          type: "error",
        });
        return false
      }
      return true
    },

    printFunction(type) {
      // const newWindow = window.open("_blank");
      // const codestr = document.getElementById(type).innerHTML;
      // newWindow.document.write(codestr);
      // newWindow.document.close();
      const newWindow = window.open("", "_blank");
      const codestr = document.getElementById(type).innerHTML;
      newWindow.document.body.innerHTML = codestr;
    },
  }
}
